import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

let reactPlugin: ReactPlugin | null = null;
let appInsights: ApplicationInsights | null = null;

/**
 * Initialize Application Insights with connection string from environment variables
 * Best practice: Connection string should be stored in environment variables
 * and configured through Azure Static Web App configuration settings
 */
export const initializeAppInsights = (): ReactPlugin | null => {
  // Get connection string from environment variable
  const connectionString = process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING;

  // Only initialize if connection string is provided
  if (!connectionString) {
    console.warn(
      'Application Insights connection string not found. Telemetry will not be collected.'
    );
    return null;
  }

  try {
    const browserHistory = createBrowserHistory();

    // Create React plugin for automatic page view tracking
    reactPlugin = new ReactPlugin();

    // Initialize Application Insights
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        enableAutoRouteTracking: false, // Automatically track route changes
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
        },
      },
    });

    appInsights.loadAppInsights();

    return reactPlugin;
  } catch (error) {
    console.error('Failed to initialize Application Insights:', error);
    return null;
  }
};

/**
 * Get the Application Insights instance for manual tracking
 */
export const getAppInsights = (): ApplicationInsights | null => {
  return appInsights;
};

/**
 * Get the React plugin instance
 */
export const getReactPlugin = (): ReactPlugin | null => {
  return reactPlugin;
};

/**
 * Track exception manually
 */
export const trackException = (error: Error, severityLevel?: number): void => {
  if (appInsights) {
    appInsights.trackException({ exception: error, severityLevel });
  }
};
